import { Box, Breadcrumbs, Card, CardContent, CardMedia, Container, CssBaseline, Grid, Link, Paper, Stack, Typography, useMediaQuery, useTheme } from '@mui/material'
import React, { useState } from 'react'
import TopHeader from '../../../../components/general/TopHeader';
import { Nav, Tab, Tabs } from 'react-bootstrap';
import { NavLink, useLocation } from 'react-router-dom';
import LoadPatternTab1 from './LoadPatternTab1/LoadPatternTab1';
import LoadPatternTab2 from './LoadPatternTab2/LoadPatternTab2';
import LoadPatternTab3 from './LoadPatternTab3/LoadPatternTab3';
import LoadPatternTab4 from './LoadPatternTab4/LoadPatternTab4';

export default function LoadPattern() {
    const { palette, typography, breakpoints, spacing } = useTheme()
    const matches = useMediaQuery(breakpoints.up('lg'));
    const [key, setKey] = useState('Load Pattern');
    const location = useLocation();


    return (
        <>
            <CssBaseline />
            <TopHeader />
            <Box mt={spacing(1)}>
                <Stack direction={'row'} sx={{ position: 'absolute', columnGap: spacing(1) }} role="presentation" >
                    <NavLink style={{ textDecoration: "none", color: palette.primary.main }}>
                        dashboard
                    </NavLink>
                    <NavLink style={{ textDecoration: "none", color: palette.primary.main }}>
                        {location?.pathname}
                    </NavLink>
                </Stack>
                <Tabs
                    style={{ justifyContent: "flex-end" }}
                    id="controlled-tab-example"
                    activeKey={key}
                    onSelect={(k) => setKey(k)}
                >
                    <Tab eventKey="Load Pattern" title="Load Pattern">
                        <LoadPatternTab1/>
                    </Tab>
                    <Tab eventKey="Load Pattern (I)" title="Load Pattern (I)">
                        <LoadPatternTab2 />
                    </Tab>
                    <Tab eventKey="Load Pattern (O)" title="Load Pattern (O)">
                        <LoadPatternTab3 />
                    </Tab>

                     <Tab eventKey="Load Pattern (S)" title="Load Pattern (S)">
                        <LoadPatternTab4 />
                    </Tab>
                </Tabs>


            </Box>
        </>

    )
}
